import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { OperatorsService } from "../../shared/services/operators.service";
import * as operatorsActions from './operators.actions';
import * as operatorsSelectors from './operators.selectors';
import { catchError, map, of, switchMap, withLatestFrom } from "rxjs";
import { Store } from "@ngrx/store";
import * as authSelectors from '../auth/auth.selectors';
import * as authActions from '../auth/auth.actions';


export class OperatorsEffects {
    action$: Actions = inject(Actions);
    operatorsService: OperatorsService = inject(OperatorsService);
    store: Store = inject(Store);

    loadOperators$ = createEffect(() =>
        this.action$.pipe(
            ofType(operatorsActions.LoadOperators),
            switchMap(() =>
                this.operatorsService.getOperators().pipe(
                    map(res => operatorsActions.LoadOperatorsSuccess({ operators: res })),
                    catchError(err => of(operatorsActions.LoadOperatorsFailure({ error: err.message || 'Operators loading failed' })))
                )
            )
        )
    );

    loadOperatorsOnLogin$ = createEffect(() =>
        this.action$.pipe(
            ofType(operatorsActions.LoadOperatorsOnLogin),
            switchMap(({defaultOperatorId}) =>
                this.operatorsService.getOperators().pipe(
                    map(res => operatorsActions.LoadOperatorsOnLoginSuccess({ operators: res, defaultOperatorId })),
                    catchError(err => of(operatorsActions.LoadOperatorsOnLoginFailure({ error: err.message || 'Operators loading failed' })))
                )
            )
        )
    );

    setDefaultOperatorForUser$ = createEffect(() =>
        this.action$.pipe(
            ofType(operatorsActions.LoadOperatorsSuccess),
            withLatestFrom(this.store.select(authSelectors.selectDefaultOperatorIdForUser)),
            map(([_, defaultOperatorId]) => {
                return operatorsActions.SetCurrentOperator({ currentOperatorId: defaultOperatorId! })
            })
        )
    );

    sendLoginSuccessfulAction$ = createEffect(
        () =>
            this.action$.pipe(
                ofType(operatorsActions.LoadOperatorsOnLoginSuccess),
                map(_res => authActions.loginSuccessful())
            )
    )

    sendLoginUnsuccessfulAction$ = createEffect(
        () =>
            this.action$.pipe(
                ofType(operatorsActions.LoadOperatorsOnLoginFailure),
                map(_res => authActions.loginUnsuccessful())
            )
    )

    setCurrentOperator$ = createEffect(() =>
        this.action$.pipe(
            ofType(operatorsActions.SetCurrentOperator),
            withLatestFrom(this.store.select(operatorsSelectors.selectOperators)),
            map(([action, operators]) => {
                const operatorId = action.currentOperatorId;
                const operator = operators.find(x => x.id === operatorId);
                if (!operator) {
                    return operatorsActions.SetCurrentOperatorFailure({ error: 'Operator not found' })
                } else {
                    return operatorsActions.SetCurrentOperatorSuccess({ currentOperator: operator });
                }
            })
        )
    )
}
